import { type FC, type ReactNode, type ChangeEvent } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';

import { Input } from 'dibs-elements/exports/Input';

type Props = {
    errorMessage?: ReactNode;
    value: string;
    isLoading?: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const messages = defineMessages({
    email: {
        id: 'DealerApplicationForm.email.placeholder',
        defaultMessage: 'Email',
    },
});

const Email: FC<Props> = ({ errorMessage, value, onChange, isLoading }) => {
    const intl = useIntl();
    return (
        <Input
            dataTn="register-email"
            name="register-email"
            placeholder={intl.formatMessage(messages.email)}
            hasAnimatedPlaceholder
            autoComplete="email"
            pattern="[^ @]*@[^ @]*"
            type="email"
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            disabled={isLoading}
            value={value}
        />
    );
};

export default Email;
